// The AdAudit Worker (Cloudflare). Starts jobs straight away.
export const PROXY_URL = "https://api.adaudit.co";
